import Swiper1 from 'images/about/swiper1.png'
import Swiper2 from 'images/about/swiper2.png'
import Swiper3 from 'images/about/swiper3.png'

export const AboutOverview = [
  'Avia (also known as Aviagames) was founded in 2017 with the goal of creating engaging and challenging gaming apps. The platform uses a sophisticated algorithm for fair competition and has gained popularity, receiving funding from Makers Fund and Galaxy Digital in 2020.',
  'Our flagship offering, Pocket7Games, unites various gaming categories under one membership and wallet system for seamless entertainment. Within just 18 months, we have made waves in the gaming industry, leading in monthly tournaments and consistently earning top spots on the App Store.',
]

export const AboutMarket = [
  'While initially focused on the US market, Avia has expanded into the UK, Canada, Germany, and Australia, with plans for further growth.',
]

export const AboutLife = {
  title: 'Life at Avia',
  list: [
    {
      title: 'Sailing Towards Success',
      image: Swiper1,
      description: [
        'Avia encourages collaboration among individuals, allowing each person to realize the potential of their respective talents through teamwork.',
        'Every member of Avia is a steadfast sailor capable of braving the seas of life by tapping into their inner strength. When the Avia crew bands together, our ship can navigate raging storms, plow through towering waves, and reach ever-distant horizons.',
      ],
    },
    {
      title: 'Creativity, Collaboration, & Courage',
      image: Swiper2,
      description: [
        "Avia's greatest strength lies in its people. By fostering individuality and critical thinking, we empower creativity and innovation. Through unity and resilience, we've grown from a humble rowboat into a mighty galleon, navigating challenges and forging our own path to success.",
        'Despite the unknown depths and stormy seas, our crew stands strong, driven by talent, shared purpose, and a forward-thinking mindset. With every wave we crest, we uncover new opportunities, ensuring that the journey ahead is as rewarding as the destination.',
      ],
    },
    {
      title: 'Holistic Wellness',
      image: Swiper3,
      description: [
        'At Avia, we believe success starts with well-being. We cultivate a supportive environment that promotes work-life balance, personal growth, and strong social connections.',
        <span key="title1" className="block pt-[0.5em] font-semibold text-white">
          Work-Life Balance
        </span>,
        'Employee well-being is a priority. With flexible work schedules, wellness programs, and resources to support mental and physical health, we help our team maintain a healthy, balanced lifestyle.',
        <span key="title2" className="block pt-[0.5em] font-semibold text-white">
          Connection & Collaboration
        </span>,
        'A thriving workplace is built on teamwork and open communication. Through team events, celebrations, and transparent collaboration, we foster a strong, united community where every voice is valued.',
      ],
    },
  ],
}

export const AboutAvia = [
  {
    title: 'Our Vision',
    content: [
      'Avia is the go-to destination for casual, skill-based competitive gaming, and the publisher of top-ranking mobile games including "Solitaire Clash," "Bingo Tour," "Bingo Clash," and the all-in-one platform, "Pocket7Games."',
      "Quick to play and quick to win, Avia's mobile games are fun, easily accessible, and designed to unleash the competitive spirit in players of all skill levels. Avia offers over 15 unique, skill-based games, allowing players to seamlessly switch among a range of puzzle, action, card, math, and board games.",
      'Avia strives to bring endless excitement to millions of players around the world with its world-class entertainment and competition platform.',
    ],
  },
  {
    title: 'Our Values',
    content: [
      'Innovation, excellence, and a relentless pursuit of growth define Avia. We embrace a culture filled with ambition, creativity, and resilience, always looking forward to the next challenge.',
      'Our values guide us as we seek opportunities to surpass industry standards and provide a gaming experience that resonates with our global community.',
      'Our mission is to deliver a fun-filled online gaming experience that is accessible to anyone, anywhere.',
    ],
  },
  {
    title: 'Instant Play, Endless Fun',
    content: [
      "If you are on the hunt for games you can dive into without a long learning curve, we've got you covered! Play instantly and enjoy endless fun anytime, anywhere.",
      'With intuitive controls and engaging gameplay, players of all skill levels can enjoy a wide variety of games, including card games, bubble shooting games, bingo games, and more.',
      'Players can participate in tournaments and win cash prizes or simply enjoy playing for fun using tickets or gems. Engage in a global community of players through interactive challenges, and stay entertained with regular updates of fresh content.',
    ],
  },
]

export const AboutCare = {
  title: 'WE CARE',
  content: [
    'At Avia, we believe in giving back to the community and making a difference beyond our work. As part of our ongoing commitment to social responsibility, all Avia employees voted to rescue two cats, Tang Tang and Jia Bao, and provide them with a permanent home at our office.',
  ],
}

export const AboutCareTangTang = {
  title: 'Hi, I’m Tang Tang.',
  content: [
    'With my one-eye look, I’d make a great pirate, but I’m all about love, not adventure. Rescued in Tangshan after an eye injury, I’ve never let it slow me down. Every day, I greet my favorite humans with happy rubs.',
    'As a chubby British Shorthair, I’m calm, gentle, and always adorable. I know basic commands, play nicely, and love a good nap. My unique look makes me special, and around here, I’m the office favorite. Stop by and say hi—I’ll be waiting.',
  ],
}

export const AboutCareJiaBao = {
  title: "Hi, I'm Jia Bao.",
  content: [
    "I lost my teeth due to stomatitis, but that hasn't affected my appetite or my love for life. More importantly, it hasn't changed my love for people.",
    "I'm the most affectionate cat in the office, always eager to jump onto laps and snuggle close. With a social charm rating of 100%, I win hearts effortlessly. I'm not just a cat—I'm a cuddle expert, always ready to bring warmth and comfort to everyone around me.",
  ],
}
